import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

import { authScopes } from '../../models/auth';

export const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_JUMP_URL,
  client_id: import.meta.env.VITE_CLIENT_ID,
  redirect_uri: window.location.origin + '/auth/redirect',
  post_logout_redirect_uri: window.location.origin + '/logout/redirect',
  scope: authScopes.join(' '),
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // monitorSession: enable once JUMP exposes check_session_iframe in its OIDC discovery document.
  monitorSession: false,
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
};
